// Full multi-language dictionary ported from the original Expo app (LangContext).
export const LANG_OPTIONS = [
  { code: "it", flag: "🇮🇹", label: "Italiano" },
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
];

export const VALID_LANGS = ["it", "en", "es", "fr", "de"];

export const translations = {
  it: {
    convertNow: "Converti ora",
    backHome: "Torna alla home",
    convertToExcel: "Converti in Excel",
    convertToWord: "Converti in Word",
    convertingExcel: "Converti in Excel",
    converting: "Conversione in corso...",
    processingNote:
      "Analisi del documento in corso. I PDF scansionati possono richiedere fino a un minuto.",
    automatic: "Automatico",
    custom: "Personalizzato",
    autoHint:
      "L'AI rileva automaticamente tabelle e struttura. Ideale per la maggior parte dei documenti.",
    customHint:
      "Descrivi cosa estrarre e come organizzarlo: l'AI seguirà le tue istruzioni alla lettera.",
    excelTitle: "Converti PDF in Excel",
    wordTitle: "Converti PDF in Word",
    excelSub:
      "Estrai tabelle e dati strutturati da qualsiasi PDF — anche scansionato o fotografato — in un foglio .xlsx pronto all'uso.",
    wordSub:
      "Trascrivi fedelmente testi e tabelle dei tuoi PDF in un documento .docx modificabile.",
    dropTitle: "Trascina qui il tuo PDF",
    dropExcelHint: "PDF fino a 50MB • Documenti digitali, scansioni e foto",
    resultPreview: "Anteprima del risultato",
    pagesLabel: "pagine",
    tablesLabel: "tabelle",
    newBtn: "Nuova",
    downloadBtn: "Scarica",
    editCellNote: "Clicca su una cella per correggerla, poi scarica il file aggiornato.",
    editWordNote: "Modifica testi e tabelle, poi scarica il documento Word aggiornato.",
    instructionsPlaceholder:
      "Es: 'Estrai solo la tabella a pagina 3 con le colonne Data, Descrizione, Importo' oppure 'metti ogni sezione della fattura in un foglio separato'",
    selectFileFirst: "Seleziona prima un file PDF",
    instrRequired: "Inserisci le istruzioni per la modalità personalizzata",
    convDone: "Conversione completata!",
    downloadStarted: "Download avviato",
    downloadFailed: "Impossibile scaricare il file",
    genericError: "Errore imprevisto",
    errTooLarge: "File troppo grande: il server accetta PDF fino a 50MB",
    errConnection: "Errore di connessione al server. Controlla la rete e riprova.",
    errServer: "Errore interno del server. Riprova tra qualche istante.",
    errTimeout: "Tempo scaduto: l'elaborazione ha impiegato troppo tempo. Riprova.",
    errRateLimit: "Troppe richieste. Attendi un minuto e riprova.",
    previewFailed:
      "Anteprima non disponibile, ma la conversione è riuscita: puoi comunque scaricare il file.",
    sheetSelectLabel: "Foglio da analizzare",
    allSheets: "Tutti i fogli",
    stageUpload: "Caricamento file",
    stageExtract: "Analisi pagine",
    stageOcr: "OCR e visione AI",
    stageAi: "Elaborazione AI",
    stageGenerate: "Generazione file",
    stageDone: "Completato",
    // Excel analysis
    analysisTitle: "Analisi Excel con AI",
    analysisSub:
      "Carica un file Excel e lascia che l'AI spieghi struttura, formule e significato dei dati. Puoi anche porre domande specifiche sul contenuto.",
    dropExcelFile: "Trascina qui il tuo file Excel",
    excelFileHint: "Excel (.xlsx, .xls) fino a 50MB",
    fullAnalysis: "Analisi completa",
    askQuestion: "Fai una domanda",
    analyzeBtn: "Analizza file",
    analyzing: "Analisi in corso...",
    analysisResult: "Risultato analisi",
    questionPlaceholder:
      "Es: 'Cosa calcola la formula nella cella D12?' oppure 'Qual è il totale delle vendite del trimestre?'",
    selectExcelFirst: "Seleziona prima un file Excel",
    writeQuestion: "Scrivi una domanda",
    analysisDone: "Analisi completata!",
    analysisError: "Errore durante l'analisi",
    sheetsLabel: "Fogli",
  },
  en: {
    convertNow: "Convert now",
    backHome: "Back to home",
    convertToExcel: "Convert to Excel",
    convertToWord: "Convert to Word",
    converting: "Converting...",
    processingNote:
      "Analysing the document. Scanned PDFs can take up to a minute.",
    automatic: "Automatic",
    custom: "Custom",
    autoHint:
      "The AI automatically detects tables and structure. Ideal for most documents.",
    customHint:
      "Describe what to extract and how to organise it: the AI follows your instructions to the letter.",
    excelTitle: "Convert PDF to Excel",
    wordTitle: "Convert PDF to Word",
    excelSub:
      "Extract tables and structured data from any PDF — even scanned or photographed — into a ready-to-use .xlsx sheet.",
    wordSub:
      "Faithfully transcribe the text and tables of your PDFs into an editable .docx document.",
    dropTitle: "Drag your PDF here",
    dropExcelHint: "PDF up to 50MB • Digital documents, scans and photos",
    resultPreview: "Result preview",
    pagesLabel: "pages",
    tablesLabel: "tables",
    newBtn: "New",
    downloadBtn: "Download",
    editCellNote: "Click a cell to correct it, then download the updated file.",
    editWordNote: "Edit text and tables, then download the updated Word document.",
    instructionsPlaceholder:
      "E.g.: 'Extract only the table on page 3 with columns Date, Description, Amount' or 'put each invoice section in a separate sheet'",
    selectFileFirst: "Please select a PDF file first",
    instrRequired: "Enter instructions for custom mode",
    convDone: "Conversion complete!",
    downloadStarted: "Download started",
    downloadFailed: "Unable to download the file",
    genericError: "Unexpected error",
    errTooLarge: "File too large: the server accepts PDFs up to 50MB",
    errConnection: "Server connection error. Check your network and try again.",
    errServer: "Internal server error. Please try again shortly.",
    errTimeout: "Timed out: processing took too long. Please try again.",
    errRateLimit: "Too many requests. Wait a minute and try again.",
    previewFailed:
      "Preview unavailable, but the conversion succeeded: you can still download the file.",
    sheetSelectLabel: "Sheet to analyse",
    allSheets: "All sheets",
    stageUpload: "Uploading file",
    stageExtract: "Analysing pages",
    stageOcr: "OCR & AI vision",
    stageAi: "AI processing",
    stageGenerate: "Generating file",
    stageDone: "Done",
    analysisTitle: "Excel Analysis with AI",
    analysisSub:
      "Upload an Excel file and let the AI explain structure, formulas and data meaning. You can also ask specific questions about the content.",
    dropExcelFile: "Drag your Excel file here",
    excelFileHint: "Excel (.xlsx, .xls) up to 50MB",
    fullAnalysis: "Full analysis",
    askQuestion: "Ask a question",
    analyzeBtn: "Analyse file",
    analyzing: "Analysing...",
    analysisResult: "Analysis result",
    questionPlaceholder:
      "E.g.: 'What does the formula in cell D12 calculate?' or 'What is the total sales for the quarter?'",
    selectExcelFirst: "Please select an Excel file first",
    writeQuestion: "Write a question",
    analysisDone: "Analysis complete!",
    analysisError: "Error during analysis",
    sheetsLabel: "Sheets",
  },
  es: {
    convertNow: "Convertir ahora",
    backHome: "Volver al inicio",
    convertToExcel: "Convertir a Excel",
    convertToWord: "Convertir a Word",
    converting: "Convirtiendo...",
    processingNote:
      "Analizando el documento. Los PDF escaneados pueden tardar hasta un minuto.",
    automatic: "Automática",
    custom: "Personalizada",
    autoHint:
      "La IA detecta automáticamente tablas y estructura. Ideal para la mayoría de documentos.",
    customHint:
      "Describe qué extraer y cómo organizarlo: la IA seguirá tus instrucciones al pie de la letra.",
    excelTitle: "Convertir PDF a Excel",
    wordTitle: "Convertir PDF a Word",
    excelSub:
      "Extrae tablas y datos estructurados de cualquier PDF — incluso escaneado o fotografiado — en una hoja .xlsx lista para usar.",
    wordSub:
      "Transcribe fielmente los textos y tablas de tus PDF en un documento .docx editable.",
    dropTitle: "Arrastra aquí tu PDF",
    dropExcelHint: "PDF hasta 50MB • Documentos digitales, escaneados y fotos",
    resultPreview: "Vista previa del resultado",
    pagesLabel: "páginas",
    tablesLabel: "tablas",
    newBtn: "Nueva",
    downloadBtn: "Descargar",
    editCellNote: "Haz clic en una celda para corregirla, luego descarga el archivo actualizado.",
    editWordNote: "Edita textos y tablas, luego descarga el documento Word actualizado.",
    instructionsPlaceholder:
      "Ej: 'Extrae solo la tabla de la página 3 con las columnas Fecha, Descripción, Importe' o 'pon cada sección de la factura en una hoja separada'",
    selectFileFirst: "Selecciona primero un archivo PDF",
    instrRequired: "Introduce las instrucciones para el modo personalizado",
    convDone: "¡Conversión completada!",
    downloadStarted: "Descarga iniciada",
    downloadFailed: "No se pudo descargar el archivo",
    genericError: "Error inesperado",
    errTooLarge: "Archivo demasiado grande: el servidor acepta PDF de hasta 50MB",
    errConnection: "Error de conexión con el servidor. Comprueba tu red e inténtalo de nuevo.",
    errServer: "Error interno del servidor. Inténtalo de nuevo en unos instantes.",
    errTimeout: "Tiempo agotado: el procesamiento tardó demasiado. Inténtalo de nuevo.",
    errRateLimit: "Demasiadas solicitudes. Espera un minuto e inténtalo de nuevo.",
    previewFailed:
      "Vista previa no disponible, pero la conversión se completó: aún puedes descargar el archivo.",
    sheetSelectLabel: "Hoja a analizar",
    allSheets: "Todas las hojas",
    stageUpload: "Subiendo archivo",
    stageExtract: "Analizando páginas",
    stageOcr: "OCR y visión IA",
    stageAi: "Procesamiento IA",
    stageGenerate: "Generando archivo",
    stageDone: "Completado",
    analysisTitle: "Análisis Excel con IA",
    analysisSub:
      "Sube un archivo Excel y deja que la IA explique estructura, fórmulas y significado de los datos. También puedes hacer preguntas específicas.",
    dropExcelFile: "Arrastra aquí tu archivo Excel",
    excelFileHint: "Excel (.xlsx, .xls) hasta 50MB",
    fullAnalysis: "Análisis completo",
    askQuestion: "Haz una pregunta",
    analyzeBtn: "Analizar archivo",
    analyzing: "Analizando...",
    analysisResult: "Resultado del análisis",
    questionPlaceholder:
      "Ej: '¿Qué calcula la fórmula de la celda D12?' o '¿Cuál es el total de ventas del trimestre?'",
    selectExcelFirst: "Selecciona primero un archivo Excel",
    writeQuestion: "Escribe una pregunta",
    analysisDone: "¡Análisis completado!",
    analysisError: "Error durante el análisis",
    sheetsLabel: "Hojas",
  },
  fr: {
    convertNow: "Convertir",
    backHome: "Retour à l'accueil",
    convertToExcel: "Convertir en Excel",
    convertToWord: "Convertir en Word",
    converting: "Conversion en cours...",
    processingNote:
      "Analyse du document en cours. Les PDF scannés peuvent prendre jusqu'à une minute.",
    automatic: "Automatique",
    custom: "Personnalisé",
    autoHint:
      "L'IA détecte automatiquement les tableaux et la structure. Idéal pour la plupart des documents.",
    customHint:
      "Décrivez quoi extraire et comment l'organiser : l'IA suit vos instructions à la lettre.",
    excelTitle: "Convertir PDF en Excel",
    wordTitle: "Convertir PDF en Word",
    excelSub:
      "Extrayez tableaux et données structurées de n'importe quel PDF — même scanné ou photographié — dans une feuille .xlsx prête à l'emploi.",
    wordSub:
      "Transcrivez fidèlement les textes et tableaux de vos PDF dans un document .docx modifiable.",
    dropTitle: "Glissez votre PDF ici",
    dropExcelHint: "PDF jusqu'à 50 Mo • Documents numériques, scans et photos",
    resultPreview: "Aperçu du résultat",
    pagesLabel: "pages",
    tablesLabel: "tableaux",
    newBtn: "Nouveau",
    downloadBtn: "Télécharger",
    editCellNote: "Cliquez sur une cellule pour la corriger, puis téléchargez le fichier mis à jour.",
    editWordNote: "Modifiez textes et tableaux, puis téléchargez le document Word mis à jour.",
    instructionsPlaceholder:
      "Ex : 'Extraire uniquement le tableau de la page 3 avec les colonnes Date, Description, Montant' ou 'mettre chaque section de la facture dans une feuille séparée'",
    selectFileFirst: "Sélectionnez d'abord un fichier PDF",
    instrRequired: "Saisissez les instructions pour le mode personnalisé",
    convDone: "Conversion terminée !",
    downloadStarted: "Téléchargement lancé",
    downloadFailed: "Impossible de télécharger le fichier",
    genericError: "Erreur inattendue",
    errTooLarge: "Fichier trop volumineux : le serveur accepte les PDF jusqu'à 50 Mo",
    errConnection: "Erreur de connexion au serveur. Vérifiez votre réseau et réessayez.",
    errServer: "Erreur interne du serveur. Veuillez réessayer dans un instant.",
    errTimeout: "Délai dépassé : le traitement a pris trop de temps. Réessayez.",
    errRateLimit: "Trop de requêtes. Attendez une minute et réessayez.",
    previewFailed:
      "Aperçu indisponible, mais la conversion a réussi : vous pouvez toujours télécharger le fichier.",
    sheetSelectLabel: "Feuille à analyser",
    allSheets: "Toutes les feuilles",
    stageUpload: "Chargement du fichier",
    stageExtract: "Analyse des pages",
    stageOcr: "OCR et vision IA",
    stageAi: "Traitement IA",
    stageGenerate: "Génération du fichier",
    stageDone: "Terminé",
    analysisTitle: "Analyse Excel avec IA",
    analysisSub:
      "Importez un fichier Excel et laissez l'IA expliquer structure, formules et signification des données. Vous pouvez aussi poser des questions précises.",
    dropExcelFile: "Glissez votre fichier Excel ici",
    excelFileHint: "Excel (.xlsx, .xls) jusqu'à 50 Mo",
    fullAnalysis: "Analyse complète",
    askQuestion: "Poser une question",
    analyzeBtn: "Analyser le fichier",
    analyzing: "Analyse en cours...",
    analysisResult: "Résultat de l'analyse",
    questionPlaceholder:
      "Ex : 'Que calcule la formule de la cellule D12 ?' ou 'Quel est le total des ventes du trimestre ?'",
    selectExcelFirst: "Sélectionnez d'abord un fichier Excel",
    writeQuestion: "Écrivez une question",
    analysisDone: "Analyse terminée !",
    analysisError: "Erreur lors de l'analyse",
    sheetsLabel: "Feuilles",
  },
  de: {
    convertNow: "Jetzt konvertieren",
    backHome: "Zurück zur Startseite",
    convertToExcel: "In Excel konvertieren",
    convertToWord: "In Word umwandeln",
    converting: "Konvertierung läuft...",
    processingNote:
      "Das Dokument wird analysiert. Gescannte PDFs können bis zu einer Minute dauern.",
    automatic: "Automatisch",
    custom: "Benutzerdefiniert",
    autoHint:
      "Die KI erkennt Tabellen und Struktur automatisch. Ideal für die meisten Dokumente.",
    customHint:
      "Beschreiben Sie, was extrahiert und wie organisiert werden soll: Die KI folgt Ihren Anweisungen genau.",
    excelTitle: "PDF in Excel konvertieren",
    wordTitle: "PDF in Word umwandeln",
    excelSub:
      "Extrahieren Sie Tabellen und strukturierte Daten aus jedem PDF — auch gescannt oder fotografiert — in eine einsatzbereite .xlsx-Datei.",
    wordSub:
      "Übertragen Sie Texte und Tabellen Ihrer PDFs originalgetreu in ein bearbeitbares .docx-Dokument.",
    dropTitle: "Ziehen Sie Ihr PDF hierher",
    dropExcelHint: "PDF bis 50 MB • Digitale Dokumente, Scans und Fotos",
    resultPreview: "Ergebnisvorschau",
    pagesLabel: "Seiten",
    tablesLabel: "Tabellen",
    newBtn: "Neu",
    downloadBtn: "Herunterladen",
    editCellNote: "Klicken Sie auf eine Zelle, um sie zu korrigieren, und laden Sie dann die aktualisierte Datei herunter.",
    editWordNote: "Bearbeiten Sie Texte und Tabellen und laden Sie dann das aktualisierte Word-Dokument herunter.",
    instructionsPlaceholder:
      "Z. B.: 'Nur die Tabelle auf Seite 3 mit den Spalten Datum, Beschreibung, Betrag extrahieren' oder 'jeden Rechnungsabschnitt in ein eigenes Blatt'",
    selectFileFirst: "Bitte zuerst eine PDF-Datei auswählen",
    instrRequired: "Geben Sie Anweisungen für den benutzerdefinierten Modus ein",
    convDone: "Konvertierung abgeschlossen!",
    downloadStarted: "Download gestartet",
    downloadFailed: "Datei konnte nicht heruntergeladen werden",
    genericError: "Unerwarteter Fehler",
    errTooLarge: "Datei zu groß: Der Server akzeptiert PDFs bis 50MB",
    errConnection: "Verbindungsfehler zum Server. Prüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
    errServer: "Interner Serverfehler. Bitte versuchen Sie es gleich noch einmal.",
    errTimeout: "Zeitüberschreitung: Die Verarbeitung hat zu lange gedauert. Bitte erneut versuchen.",
    errRateLimit: "Zu viele Anfragen. Warten Sie eine Minute und versuchen Sie es erneut.",
    previewFailed:
      "Vorschau nicht verfügbar, aber die Konvertierung war erfolgreich: Sie können die Datei trotzdem herunterladen.",
    sheetSelectLabel: "Zu analysierendes Blatt",
    allSheets: "Alle Blätter",
    stageUpload: "Datei wird hochgeladen",
    stageExtract: "Seitenanalyse",
    stageOcr: "OCR & KI-Vision",
    stageAi: "KI-Verarbeitung",
    stageGenerate: "Datei wird erstellt",
    stageDone: "Fertig",
    analysisTitle: "Excel-Analyse mit KI",
    analysisSub:
      "Laden Sie eine Excel-Datei hoch und lassen Sie die KI Struktur, Formeln und Datenbedeutung erklären. Sie können auch gezielte Fragen stellen.",
    dropExcelFile: "Ziehen Sie Ihre Excel-Datei hierher",
    excelFileHint: "Excel (.xlsx, .xls) bis 50 MB",
    fullAnalysis: "Vollständige Analyse",
    askQuestion: "Frage stellen",
    analyzeBtn: "Datei analysieren",
    analyzing: "Analyse läuft...",
    analysisResult: "Analyseergebnis",
    questionPlaceholder:
      "Z. B.: 'Was berechnet die Formel in Zelle D12?' oder 'Wie hoch ist der Gesamtumsatz des Quartals?'",
    selectExcelFirst: "Bitte zuerst eine Excel-Datei auswählen",
    writeQuestion: "Schreiben Sie eine Frage",
    analysisDone: "Analyse abgeschlossen!",
    analysisError: "Fehler bei der Analyse",
    sheetsLabel: "Blätter",
  },
};

// Landing page copy (IT + EN). Other languages fall back to EN (original behaviour).
const landingIt = {
  heroEyebrow: "OCR ibrido + Intelligenza Artificiale",
  heroTitlePre: "Convertitore PDF in Excel con ",
  heroTitleHi: "precisione millimetrica",
  heroSub:
    "Dotec EW-PDF trasforma PDF, scansioni e fotografie di documenti in tabelle Excel perfettamente strutturate. Dove gli altri convertitori si arrendono — pagine ruotate, timbri, colonne fitte — il nostro motore OCR legge, verifica e ricostruisce ogni singola cella.",
  heroBadges: ["Anche PDF scansionati e foto", "Pagine ruotate raddrizzate", "Anteprima modificabile"],
  toolsTitle: "Tutti gli strumenti Dotec",
  toolsSub: "Una suite completa per lavorare con PDF, Excel e Word.",
  toolExcel: { title: "PDF → Excel", text: "Estrai tabelle e dati strutturati da qualsiasi PDF, anche scansionato, in fogli .xlsx pronti all'uso.", cta: "Converti in Excel" },
  toolWord: { title: "PDF → Word", text: "Trascrivi fedelmente testi e tabelle dei tuoi PDF in documenti .docx modificabili.", cta: "Converti in Word" },
  toolImage: { title: "Immagine → PDF", text: "Trasforma istantaneamente le tue foto o scansioni in PDF pronti per la conversione.", cta: "Crea il PDF" },
  toolCompress: { title: "Comprimi PDF", text: "Riduci drasticamente il peso di PDF e immagini: da centinaia di MB a pochi MB, tutto nel browser.", cta: "Comprimi ora" },
  toolAnalysis: { title: "Analisi PDF/Excel", text: "Fai domande sui tuoi file Excel: struttura, formule e significato dei dati spiegati dall'AI.", cta: "Analizza un file" },
  toolEdit: { title: "Modifica PDF", text: "Aggiungi testo, immagini e firme, ruota, riordina e unisci pagine, poi scarica il nuovo PDF. Tutto nel browser.", cta: "Apri l'editor" },
  suiteEyebrow: "Suite PDF completa",
  suiteTitlePre: "Tutti i tuoi strumenti PDF ",
  suiteTitleHi: "in un unico posto",
  suiteSub: "Converti, analizza e modifica i tuoi documenti PDF con la potenza dell'OCR ibrido e dell'intelligenza artificiale. Scegli lo strumento e inizia subito.",
  newBadge: "Novità",
  openTool: "Apri strumento",
  howTitle: "Come funziona Dotec",
  howSub: "Dal documento al foglio di calcolo in tre passaggi, senza installare nulla.",
  steps: [
    { title: "1. Carica il tuo PDF", text: "Trascina o seleziona un file fino a 50MB: contratti, fatture, listini, referti o fotografie di tabelle scattate con lo smartphone." },
    { title: "2. L'AI analizza ogni cella", text: "Il motore ibrido combina OCR ad alta risoluzione e visione artificiale: la struttura viene ricostruita riga per riga, con verifica incrociata di ogni valore." },
    { title: "3. Controlla, correggi, scarica", text: "Ricevi un'anteprima fedele e modificabile: correggi una cella con un click e rigenera il file istantaneamente. Pronto per l'uso professionale." },
  ],
  whyTitle: "Perché scegliere noi per le scansioni",
  whyPara1:
    "La maggior parte dei convertitori PDF funziona solo con documenti digitali perfetti e fallisce davanti a una scansione reale: pagine acquisite di traverso, righe sbiadite, timbri sovrapposti, tabelle fitte di numeri. Dotec EW-PDF è stato progettato esattamente per questi casi difficili.",
  whyPara2:
    "Ogni pagina scansionata attraversa una pipeline dedicata: rilevamento deterministico dell'orientamento, OCR a bande orizzontali per una griglia di celle precisa e, infine, un modello di visione artificiale che confronta il risultato con l'immagine originale. È questo triplo controllo a fare la differenza.",
  whyBullets: [
    { title: "Rotazione corretta automaticamente", text: "Le pagine acquisite a 90° o 270° vengono riconosciute e raddrizzate prima dell'analisi." },
    { title: "Colonne che non slittano", text: "La griglia OCR è ancorata a confini di colonna calcolati: ogni valore finisce nella cella giusta." },
    { title: "Verifica incrociata dei numeri", text: "Cifre e importi letti dall'OCR vengono confrontati con l'immagine della pagina dal modello di visione AI." },
    { title: "Tabelle multiple e disomogenee", text: "Fatture e documenti con più tabelle diverse vengono organizzati in sezioni ordinate, ognuna con le proprie intestazioni." },
  ],
  ocrTitle: "Precisione OCR",
  ocrPara:
    "La precisione non è un dettaglio: una sola cifra fuori posto compromette un intero bilancio. Per questo l'analisi di ogni pagina avviene in tre fasi — analisi strutturale, lettura ancorata riga per riga, validazione finale — e ogni numero viene verificato due volte prima di entrare nel tuo foglio Excel.",
  ocrStats: [
    { value: "3", label: "fasi di analisi per ogni pagina scansionata" },
    { value: "2×", label: "verifica su ogni cifra estratta (OCR + AI vision)" },
    { value: "100%", label: "struttura tabellare preservata, intestazioni incluse" },
    { value: "50MB", label: "dimensione massima del file supportata" },
  ],
  ctaTitle: "Pronto a convertire il tuo primo PDF?",
  ctaSub: "Elaborazione sicura • Nessuna registrazione • File eliminati dopo l'uso",
  ctaBtn: "Inizia ora",
};

const landingEn = {
  heroEyebrow: "Hybrid OCR + Artificial Intelligence",
  heroTitlePre: "PDF to Excel converter with ",
  heroTitleHi: "millimetric precision",
  heroSub:
    "Dotec EW-PDF turns PDFs, scans and photographs of documents into perfectly structured Excel tables. Where other converters give up — rotated pages, stamps, dense columns — our OCR engine reads, verifies and rebuilds every single cell.",
  heroBadges: ["Scanned PDFs and photos", "Rotated pages straightened", "Editable preview"],
  toolsTitle: "All Dotec tools",
  toolsSub: "A complete suite for working with PDF, Excel and Word.",
  toolExcel: { title: "PDF → Excel", text: "Extract tables and structured data from any PDF, even scanned, into ready-to-use .xlsx sheets.", cta: "Convert to Excel" },
  toolWord: { title: "PDF → Word", text: "Faithfully transcribe the text and tables of your PDFs into editable .docx documents.", cta: "Convert to Word" },
  toolImage: { title: "Image → PDF", text: "Instantly turn your photos or scans into PDFs ready for conversion.", cta: "Create the PDF" },
  toolCompress: { title: "Compress PDF", text: "Drastically reduce the weight of PDFs and images: from hundreds of MB to a few MB, all in the browser.", cta: "Compress now" },
  toolAnalysis: { title: "PDF/Excel Analysis", text: "Ask questions about your Excel files: structure, formulas and data meaning explained by AI.", cta: "Analyse a file" },
  toolEdit: { title: "Edit PDF", text: "Add text, images and signatures, rotate, reorder and merge pages, then download the new PDF. All in your browser.", cta: "Open the editor" },
  suiteEyebrow: "Complete PDF suite",
  suiteTitlePre: "All your PDF tools ",
  suiteTitleHi: "in one place",
  suiteSub: "Convert, analyse and edit your PDF documents with the power of hybrid OCR and artificial intelligence. Pick a tool and start right away.",
  newBadge: "New",
  openTool: "Open tool",
  howTitle: "How Dotec works",
  howSub: "From document to spreadsheet in three steps, nothing to install.",
  steps: [
    { title: "1. Upload your PDF", text: "Drag or select a file up to 50MB: contracts, invoices, price lists, reports, or photographs of tables taken with your smartphone." },
    { title: "2. AI analyses every cell", text: "The hybrid engine combines high-resolution OCR with computer vision: the table structure is rebuilt row by row, with cross-verification of every value." },
    { title: "3. Review, correct, download", text: "You get a faithful, editable preview: fix a cell with one click and regenerate the file instantly. Ready for professional use." },
  ],
  whyTitle: "Why choose us for scans",
  whyPara1:
    "Most PDF converters only work with flawless digital documents and fail on real-world scans: pages captured sideways, faded lines, overlapping stamps, tables packed with numbers. Dotec EW-PDF was engineered precisely for these hard cases.",
  whyPara2:
    "Every scanned page goes through a dedicated pipeline: deterministic orientation detection, horizontal-band OCR to build a precise cell grid and, finally, an AI vision model that compares the result against the original page image. This triple check makes the difference.",
  whyBullets: [
    { title: "Rotation corrected automatically", text: "Pages captured at 90° or 270° are detected and straightened before analysis." },
    { title: "Columns that never drift", text: "The OCR grid is anchored to computed column boundaries: every value lands in the right cell." },
    { title: "Cross-verified numbers", text: "Digits and amounts read by the OCR are checked against the page image by the AI vision model." },
    { title: "Multiple, heterogeneous tables", text: "Invoices and documents with several different tables are organised into ordered sections, each with its own headers." },
  ],
  ocrTitle: "OCR precision",
  ocrPara:
    "Precision is not a detail: a single misplaced digit can compromise an entire balance sheet. That is why every page is analysed in three phases — structural analysis, row-anchored reading, final validation — and every number is verified twice before it enters your Excel sheet.",
  ocrStats: [
    { value: "3", label: "analysis phases for every scanned page" },
    { value: "2×", label: "verification of every extracted digit (OCR + AI vision)" },
    { value: "100%", label: "table structure preserved, headers included" },
    { value: "50MB", label: "maximum supported file size" },
  ],
  ctaTitle: "Ready to convert your first PDF?",
  ctaSub: "Secure processing • No sign-up • Files deleted after use",
  ctaBtn: "Start now",
};

export function getLandingCopy(lang) {
  return LANDING_COPY[lang] || landingEn;
}

const landingEs = {
  heroEyebrow: "OCR híbrido + Inteligencia Artificial",
  heroTitlePre: "Conversor de PDF a Excel con ",
  heroTitleHi: "precisión milimétrica",
  heroSub:
    "Dotec EW-PDF transforma PDF, escaneos y fotografías de documentos en tablas Excel perfectamente estructuradas. Donde otros conversores se rinden — páginas giradas, sellos, columnas densas — nuestro motor OCR lee, verifica y reconstruye cada celda.",
  heroBadges: ["También PDF escaneados y fotos", "Páginas giradas enderezadas", "Vista previa editable"],
  toolsTitle: "Todas las herramientas Dotec",
  toolsSub: "Una suite completa para trabajar con PDF, Excel y Word.",
  toolExcel: { title: "PDF → Excel", text: "Extrae tablas y datos estructurados de cualquier PDF, incluso escaneado, en hojas .xlsx listas para usar.", cta: "Convertir a Excel" },
  toolWord: { title: "PDF → Word", text: "Transcribe fielmente los textos y tablas de tus PDF en documentos .docx editables.", cta: "Convertir a Word" },
  toolImage: { title: "Imagen → PDF", text: "Convierte al instante tus fotos o escaneos en PDF listos para la conversión.", cta: "Crear el PDF" },
  toolCompress: { title: "Comprimir PDF", text: "Reduce drásticamente el peso de PDF e imágenes: de cientos de MB a unos pocos, todo en el navegador.", cta: "Comprimir ahora" },
  toolAnalysis: { title: "Análisis PDF/Excel", text: "Haz preguntas sobre tus archivos Excel: estructura, fórmulas y significado de los datos explicados por la IA.", cta: "Analizar un archivo" },
  toolEdit: { title: "Editar PDF", text: "Añade texto, imágenes y firmas, rota, reordena y une páginas, luego descarga el nuevo PDF. Todo en tu navegador.", cta: "Abrir el editor" },
  suiteEyebrow: "Suite PDF completa",
  suiteTitlePre: "Todas tus herramientas PDF ",
  suiteTitleHi: "en un solo lugar",
  suiteSub: "Convierte, analiza y edita tus documentos PDF con la potencia del OCR híbrido y la inteligencia artificial. Elige la herramienta y empieza ya.",
  newBadge: "Novedad",
  openTool: "Abrir herramienta",
  howTitle: "Cómo funciona Dotec",
  howSub: "Del documento a la hoja de cálculo en tres pasos, sin instalar nada.",
  steps: [
    { title: "1. Sube tu PDF", text: "Arrastra o selecciona un archivo de hasta 50MB: contratos, facturas, listas de precios, informes o fotografías de tablas hechas con el móvil." },
    { title: "2. La IA analiza cada celda", text: "El motor híbrido combina OCR de alta resolución y visión artificial: la estructura se reconstruye fila por fila, con verificación cruzada de cada valor." },
    { title: "3. Revisa, corrige, descarga", text: "Recibes una vista previa fiel y editable: corrige una celda con un clic y regenera el archivo al instante. Listo para uso profesional." },
  ],
  whyTitle: "Por qué elegirnos para los escaneos",
  whyPara1:
    "La mayoría de los conversores PDF solo funcionan con documentos digitales perfectos y fallan ante un escaneo real: páginas torcidas, líneas desvaídas, sellos superpuestos, tablas llenas de números. Dotec EW-PDF fue diseñado exactamente para estos casos difíciles.",
  whyPara2:
    "Cada página escaneada pasa por un proceso dedicado: detección determinista de la orientación, OCR por bandas horizontales para una cuadrícula precisa de celdas y, por último, un modelo de visión artificial que compara el resultado con la imagen original. Este triple control marca la diferencia.",
  whyBullets: [
    { title: "Rotación corregida automáticamente", text: "Las páginas capturadas a 90° o 270° se reconocen y enderezan antes del análisis." },
    { title: "Columnas que no se desplazan", text: "La cuadrícula OCR está anclada a límites de columna calculados: cada valor acaba en la celda correcta." },
    { title: "Verificación cruzada de los números", text: "Las cifras leídas por el OCR se comparan con la imagen de la página mediante el modelo de visión IA." },
    { title: "Tablas múltiples y heterogéneas", text: "Facturas y documentos con varias tablas distintas se organizan en secciones ordenadas, cada una con sus encabezados." },
  ],
  ocrTitle: "Precisión OCR",
  ocrPara:
    "La precisión no es un detalle: una sola cifra fuera de lugar compromete un balance entero. Por eso el análisis de cada página ocurre en tres fases — análisis estructural, lectura anclada fila por fila, validación final — y cada número se verifica dos veces antes de entrar en tu hoja Excel.",
  ocrStats: [
    { value: "3", label: "fases de análisis por cada página escaneada" },
    { value: "2×", label: "verificación de cada cifra extraída (OCR + visión IA)" },
    { value: "100%", label: "estructura de tabla preservada, encabezados incluidos" },
    { value: "50MB", label: "tamaño máximo de archivo admitido" },
  ],
  ctaTitle: "¿Listo para convertir tu primer PDF?",
  ctaSub: "Procesamiento seguro • Sin registro • Archivos eliminados tras el uso",
  ctaBtn: "Empezar ahora",
};

const landingFr = {
  heroEyebrow: "OCR hybride + Intelligence Artificielle",
  heroTitlePre: "Convertisseur PDF en Excel avec ",
  heroTitleHi: "une précision millimétrique",
  heroSub:
    "Dotec EW-PDF transforme PDF, scans et photographies de documents en tableaux Excel parfaitement structurés. Là où les autres convertisseurs abandonnent — pages pivotées, tampons, colonnes denses — notre moteur OCR lit, vérifie et reconstruit chaque cellule.",
  heroBadges: ["PDF scannés et photos aussi", "Pages pivotées redressées", "Aperçu modifiable"],
  toolsTitle: "Tous les outils Dotec",
  toolsSub: "Une suite complète pour travailler avec PDF, Excel et Word.",
  toolExcel: { title: "PDF → Excel", text: "Extrayez tableaux et données structurées de n'importe quel PDF, même scanné, en feuilles .xlsx prêtes à l'emploi.", cta: "Convertir en Excel" },
  toolWord: { title: "PDF → Word", text: "Transcrivez fidèlement textes et tableaux de vos PDF en documents .docx modifiables.", cta: "Convertir en Word" },
  toolImage: { title: "Image → PDF", text: "Transformez instantanément vos photos ou scans en PDF prêts pour la conversion.", cta: "Créer le PDF" },
  toolCompress: { title: "Compresser PDF", text: "Réduisez drastiquement le poids des PDF et images : de centaines de Mo à quelques Mo, tout dans le navigateur.", cta: "Compresser" },
  toolAnalysis: { title: "Analyse PDF/Excel", text: "Posez des questions sur vos fichiers Excel : structure, formules et signification des données expliquées par l'IA.", cta: "Analyser un fichier" },
  toolEdit: { title: "Modifier PDF", text: "Ajoutez texte, images et signatures, pivotez, réorganisez et fusionnez les pages, puis téléchargez le nouveau PDF. Tout dans votre navigateur.", cta: "Ouvrir l'éditeur" },
  suiteEyebrow: "Suite PDF complète",
  suiteTitlePre: "Tous vos outils PDF ",
  suiteTitleHi: "au même endroit",
  suiteSub: "Convertissez, analysez et modifiez vos documents PDF avec la puissance de l'OCR hybride et de l'intelligence artificielle. Choisissez l'outil et commencez tout de suite.",
  newBadge: "Nouveau",
  openTool: "Ouvrir l'outil",
  howTitle: "Comment fonctionne Dotec",
  howSub: "Du document à la feuille de calcul en trois étapes, sans rien installer.",
  steps: [
    { title: "1. Importez votre PDF", text: "Glissez ou sélectionnez un fichier jusqu'à 50 Mo : contrats, factures, tarifs, rapports ou photographies de tableaux prises au smartphone." },
    { title: "2. L'IA analyse chaque cellule", text: "Le moteur hybride combine OCR haute résolution et vision artificielle : la structure est reconstruite ligne par ligne, avec vérification croisée de chaque valeur." },
    { title: "3. Vérifiez, corrigez, téléchargez", text: "Vous recevez un aperçu fidèle et modifiable : corrigez une cellule d'un clic et régénérez le fichier instantanément. Prêt pour un usage professionnel." },
  ],
  whyTitle: "Pourquoi nous choisir pour les scans",
  whyPara1:
    "La plupart des convertisseurs PDF ne fonctionnent qu'avec des documents numériques parfaits et échouent face à un scan réel : pages de travers, lignes pâlies, tampons superposés, tableaux denses. Dotec EW-PDF a été conçu exactement pour ces cas difficiles.",
  whyPara2:
    "Chaque page scannée traverse un pipeline dédié : détection déterministe de l'orientation, OCR par bandes horizontales pour une grille de cellules précise et, enfin, un modèle de vision artificielle qui compare le résultat à l'image originale. Ce triple contrôle fait la différence.",
  whyBullets: [
    { title: "Rotation corrigée automatiquement", text: "Les pages capturées à 90° ou 270° sont reconnues et redressées avant l'analyse." },
    { title: "Des colonnes qui ne glissent pas", text: "La grille OCR est ancrée à des limites de colonnes calculées : chaque valeur atterrit dans la bonne cellule." },
    { title: "Vérification croisée des chiffres", text: "Les chiffres lus par l'OCR sont comparés à l'image de la page par le modèle de vision IA." },
    { title: "Tableaux multiples et hétérogènes", text: "Factures et documents à plusieurs tableaux sont organisés en sections ordonnées, chacune avec ses en-têtes." },
  ],
  ocrTitle: "Précision OCR",
  ocrPara:
    "La précision n'est pas un détail : un seul chiffre mal placé compromet tout un bilan. C'est pourquoi chaque page est analysée en trois phases — analyse structurelle, lecture ancrée ligne par ligne, validation finale — et chaque nombre est vérifié deux fois avant d'entrer dans votre feuille Excel.",
  ocrStats: [
    { value: "3", label: "phases d'analyse pour chaque page scannée" },
    { value: "2×", label: "vérification de chaque chiffre extrait (OCR + vision IA)" },
    { value: "100%", label: "structure des tableaux préservée, en-têtes compris" },
    { value: "50MB", label: "taille maximale de fichier prise en charge" },
  ],
  ctaTitle: "Prêt à convertir votre premier PDF ?",
  ctaSub: "Traitement sécurisé • Sans inscription • Fichiers supprimés après usage",
  ctaBtn: "Commencer",
};

const landingDe = {
  heroEyebrow: "Hybride OCR + Künstliche Intelligenz",
  heroTitlePre: "PDF-zu-Excel-Konverter mit ",
  heroTitleHi: "millimetergenauer Präzision",
  heroSub:
    "Dotec EW-PDF verwandelt PDFs, Scans und Dokumentfotos in perfekt strukturierte Excel-Tabellen. Wo andere Konverter aufgeben — gedrehte Seiten, Stempel, dichte Spalten — liest, prüft und rekonstruiert unsere OCR-Engine jede einzelne Zelle.",
  heroBadges: ["Auch gescannte PDFs und Fotos", "Gedrehte Seiten ausgerichtet", "Bearbeitbare Vorschau"],
  toolsTitle: "Alle Dotec-Werkzeuge",
  toolsSub: "Eine komplette Suite für die Arbeit mit PDF, Excel und Word.",
  toolExcel: { title: "PDF → Excel", text: "Extrahieren Sie Tabellen und strukturierte Daten aus jedem PDF, auch gescannt, in einsatzbereite .xlsx-Dateien.", cta: "In Excel konvertieren" },
  toolWord: { title: "PDF → Word", text: "Übertragen Sie Texte und Tabellen Ihrer PDFs originalgetreu in bearbeitbare .docx-Dokumente.", cta: "In Word umwandeln" },
  toolImage: { title: "Bild → PDF", text: "Verwandeln Sie Ihre Fotos oder Scans sofort in konvertierungsbereite PDFs.", cta: "PDF erstellen" },
  toolCompress: { title: "PDF komprimieren", text: "Reduzieren Sie das Gewicht von PDFs und Bildern drastisch: von Hunderten MB auf wenige — alles im Browser.", cta: "Jetzt komprimieren" },
  toolAnalysis: { title: "PDF/Excel-Analyse", text: "Stellen Sie Fragen zu Ihren Excel-Dateien: Struktur, Formeln und Datenbedeutung von der KI erklärt.", cta: "Datei analysieren" },
  toolEdit: { title: "PDF bearbeiten", text: "Fügen Sie Text, Bilder und Unterschriften hinzu, drehen, ordnen und vereinen Sie Seiten, dann laden Sie das neue PDF herunter. Alles im Browser.", cta: "Editor öffnen" },
  suiteEyebrow: "Komplette PDF-Suite",
  suiteTitlePre: "Alle Ihre PDF-Werkzeuge ",
  suiteTitleHi: "an einem Ort",
  suiteSub: "Konvertieren, analysieren und bearbeiten Sie Ihre PDF-Dokumente mit der Kraft hybrider OCR und künstlicher Intelligenz. Werkzeug wählen und sofort loslegen.",
  newBadge: "Neu",
  openTool: "Werkzeug öffnen",
  howTitle: "So funktioniert Dotec",
  howSub: "Vom Dokument zur Tabelle in drei Schritten, ohne Installation.",
  steps: [
    { title: "1. PDF hochladen", text: "Ziehen oder wählen Sie eine Datei bis 50 MB: Verträge, Rechnungen, Preislisten, Berichte oder mit dem Smartphone fotografierte Tabellen." },
    { title: "2. Die KI analysiert jede Zelle", text: "Die hybride Engine kombiniert hochauflösende OCR mit Computer Vision: Die Struktur wird Zeile für Zeile rekonstruiert, mit Kreuzprüfung jedes Wertes." },
    { title: "3. Prüfen, korrigieren, herunterladen", text: "Sie erhalten eine getreue, bearbeitbare Vorschau: Korrigieren Sie eine Zelle mit einem Klick und erzeugen Sie die Datei sofort neu. Bereit für den professionellen Einsatz." },
  ],
  whyTitle: "Warum wir bei Scans die richtige Wahl sind",
  whyPara1:
    "Die meisten PDF-Konverter funktionieren nur mit perfekten digitalen Dokumenten und scheitern an echten Scans: schief erfasste Seiten, verblasste Linien, überlagernde Stempel, zahlendichte Tabellen. Dotec EW-PDF wurde genau für diese schwierigen Fälle entwickelt.",
  whyPara2:
    "Jede gescannte Seite durchläuft eine eigene Pipeline: deterministische Ausrichtungserkennung, OCR in horizontalen Bändern für ein präzises Zellenraster und schließlich ein KI-Vision-Modell, das das Ergebnis mit dem Originalbild vergleicht. Diese dreifache Kontrolle macht den Unterschied.",
  whyBullets: [
    { title: "Automatisch korrigierte Drehung", text: "Mit 90° oder 270° erfasste Seiten werden erkannt und vor der Analyse ausgerichtet." },
    { title: "Spalten, die nicht verrutschen", text: "Das OCR-Raster ist an berechnete Spaltengrenzen verankert: Jeder Wert landet in der richtigen Zelle." },
    { title: "Kreuzgeprüfte Zahlen", text: "Von der OCR gelesene Ziffern und Beträge werden vom KI-Vision-Modell mit dem Seitenbild abgeglichen." },
    { title: "Mehrere, uneinheitliche Tabellen", text: "Rechnungen und Dokumente mit verschiedenen Tabellen werden in geordnete Abschnitte mit eigenen Überschriften organisiert." },
  ],
  ocrTitle: "OCR-Präzision",
  ocrPara:
    "Präzision ist kein Detail: Eine einzige falsch platzierte Ziffer kann eine ganze Bilanz gefährden. Deshalb wird jede Seite in drei Phasen analysiert — Strukturanalyse, zeilenverankertes Lesen, finale Validierung — und jede Zahl zweimal geprüft, bevor sie in Ihre Excel-Tabelle gelangt.",
  ocrStats: [
    { value: "3", label: "Analysephasen für jede gescannte Seite" },
    { value: "2×", label: "Prüfung jeder extrahierten Ziffer (OCR + KI-Vision)" },
    { value: "100%", label: "Tabellenstruktur erhalten, inklusive Überschriften" },
    { value: "50MB", label: "maximal unterstützte Dateigröße" },
  ],
  ctaTitle: "Bereit, Ihr erstes PDF zu konvertieren?",
  ctaSub: "Sichere Verarbeitung • Keine Registrierung • Dateien nach Gebrauch gelöscht",
  ctaBtn: "Jetzt starten",
};

const LANDING_COPY = { it: landingIt, en: landingEn, es: landingEs, fr: landingFr, de: landingDe };
